/* Chitral House — Health Tools v1.0
   Pure calculation functions (CHHT.calc) + DOM controllers. No dependencies. */
(function (root) {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  CALCULATIONS                                                        */
  /* ------------------------------------------------------------------ */
  var r1 = function (n) { return Math.round(n * 10) / 10; };
  var r0 = Math.round;

  var calc = {};

  calc.bmi = function (kg, cm) { var m = cm / 100; return kg / (m * m); };

  calc.bmiCategory = function (bmi, asian) {
    var b = r1(bmi);
    if (b < 18.5) return { key: 'under', label: 'Underweight', tone: 'info' };
    if (asian) {
      if (b < 23) return { key: 'healthy', label: 'Healthy weight', tone: 'ok' };
      if (b < 27.5) return { key: 'over', label: 'Overweight', tone: 'warn' };
      return { key: 'obese', label: 'Obese', tone: 'danger' };
    }
    if (b < 25) return { key: 'healthy', label: 'Healthy weight', tone: 'ok' };
    if (b < 30) return { key: 'over', label: 'Overweight', tone: 'warn' };
    if (b < 35) return { key: 'obese1', label: 'Obese (class I)', tone: 'high' };
    if (b < 40) return { key: 'obese2', label: 'Obese (class II)', tone: 'danger' };
    return { key: 'obese3', label: 'Obese (class III)', tone: 'danger' };
  };

  calc.healthyRange = function (cm, asian) {
    var m = cm / 100, h2 = m * m;
    return { min: 18.5 * h2, max: (asian ? 22.9 : 24.9) * h2 };
  };

  calc.bp = function (sys, dia) {
    if (sys > 180 || dia > 120) return { key: 'crisis', label: 'Hypertensive crisis', tone: 'danger' };
    if (sys >= 140 || dia >= 90) return { key: 'stage2', label: 'High blood pressure – Stage 2', tone: 'danger' };
    if (sys >= 130 || dia >= 80) return { key: 'stage1', label: 'High blood pressure – Stage 1', tone: 'high' };
    if (sys >= 120 && dia < 80) return { key: 'elevated', label: 'Elevated', tone: 'warn' };
    if (sys < 90 || dia < 60) return { key: 'low', label: 'Low blood pressure', tone: 'info' };
    return { key: 'normal', label: 'Normal', tone: 'ok' };
  };

  calc.pulse = function (bpm) {
    if (bpm < 60) return { key: 'low', label: 'Below 60 bpm (low)', tone: 'info' };
    if (bpm > 100) return { key: 'high', label: 'Above 100 bpm (high)', tone: 'warn' };
    return { key: 'normal', label: 'Typical resting range', tone: 'ok' };
  };

  calc.ACTIVITY = {
    sedentary: { f: 1.2, label: 'Sedentary' },
    light: { f: 1.375, label: 'Lightly active' },
    moderate: { f: 1.55, label: 'Moderately active' },
    very: { f: 1.725, label: 'Very active' },
    extra: { f: 1.9, label: 'Extra active' }
  };
  calc.GOALS = {
    lose500: { d: -500, label: 'Lose 0.5 kg/week' },
    lose250: { d: -250, label: 'Lose 0.25 kg/week' },
    maintain: { d: 0, label: 'Maintain weight' },
    gain250: { d: 250, label: 'Gain 0.25 kg/week' },
    gain500: { d: 500, label: 'Gain 0.5 kg/week' }
  };

  calc.calories = function (o) {
    var bmr = 10 * o.kg + 6.25 * o.cm - 5 * o.age + (o.sex === 'male' ? 5 : -161);
    var tdee = bmr * calc.ACTIVITY[o.activity].f;
    var goal = calc.GOALS[o.goal];
    var target = tdee + goal.d;
    var floor = o.sex === 'male' ? 1500 : 1200;
    var clamped = false;
    if (target < floor) { target = floor; clamped = true; }
    var pr;
    if (goal.d < 0) pr = [1.2, 1.6];
    else if (goal.d > 0) pr = [1.6, 2.2];
    else if (o.activity === 'sedentary') pr = [0.8, 1.0];
    else if (o.activity === 'light') pr = [1.0, 1.4];
    else pr = [1.2, 1.6];
    var bmi = calc.bmi(o.kg, o.cm);
    var refKg = o.kg, usedRef = false;
    if (bmi >= 30) { refKg = 25 * Math.pow(o.cm / 100, 2); usedRef = true; }
    var pMin = pr[0] * refKg, pMax = pr[1] * refKg;
    var fatMin = target * 0.25 / 9, fatMax = target * 0.30 / 9;
    var pMid = (pMin + pMax) / 2, fatMid = target * 0.275 / 9;
    var carbs = Math.max(0, (target - pMid * 4 - fatMid * 9) / 4);
    return {
      bmr: bmr, tdee: tdee, target: target, clamped: clamped, floor: floor,
      protein: [pMin, pMax], proteinPerKg: pr, refKg: refKg, usedRef: usedRef,
      fat: [fatMin, fatMax], carbs: carbs, wantedTarget: tdee + goal.d
    };
  };

  calc.idrs = function (o) {
    var age = o.age < 35 ? 0 : (o.age < 50 ? 20 : 30);
    var w = o.waist, waist;
    if (o.sex === 'female') waist = w < 80 ? 0 : (w < 90 ? 10 : 20);
    else waist = w < 90 ? 0 : (w < 100 ? 10 : 20);
    var act = { vigorous: 0, moderate: 10, mild: 20, none: 30 }[o.activity];
    var fam = { none: 0, one: 10, both: 20 }[o.family];
    var total = age + waist + act + fam;
    var band = total < 30 ? { key: 'low', label: 'Low risk', tone: 'ok' }
      : (total < 60 ? { key: 'moderate', label: 'Moderate risk', tone: 'warn' }
        : { key: 'high', label: 'High risk', tone: 'danger' });
    return { total: total, parts: { age: age, waist: waist, activity: act, family: fam }, band: band };
  };

  calc.ibw = function (sex, cm) {
    var inches = cm / 2.54 - 60;
    var m = sex === 'male';
    return {
      valid: cm >= 152.4,
      devine: (m ? 50 : 45.5) + 2.3 * inches,
      robinson: (m ? 52 : 49) + (m ? 1.9 : 1.7) * inches,
      miller: (m ? 56.2 : 53.1) + (m ? 1.41 : 1.36) * inches,
      hamwi: (m ? 48 : 45.5) + (m ? 2.7 : 2.2) * inches
    };
  };

  calc.whtr = function (waist, height) {
    var r = waist / height, rr = Math.round(r * 100) / 100;
    var band = rr < 0.40 ? { key: 'low', label: 'Low – may indicate underweight', tone: 'info' }
      : rr < 0.50 ? { key: 'healthy', label: 'Healthy', tone: 'ok' }
        : rr < 0.60 ? { key: 'increased', label: 'Increased health risk', tone: 'warn' }
          : { key: 'high', label: 'High health risk', tone: 'danger' };
    return { ratio: r, band: band };
  };

  calc.waistRisk = function (sex, cm, asian) {
    if (asian) {
      var t = sex === 'male' ? 90 : 80;
      return cm >= t ? { label: 'Above South Asian cut-off (' + t + ' cm)', tone: 'warn' } : { label: 'Within South Asian cut-off (< ' + t + ' cm)', tone: 'ok' };
    }
    var inc = sex === 'male' ? 94 : 80, hi = sex === 'male' ? 102 : 88;
    if (cm >= hi) return { label: 'High risk (≥ ' + hi + ' cm)', tone: 'danger' };
    if (cm >= inc) return { label: 'Increased risk (≥ ' + inc + ' cm)', tone: 'warn' };
    return { label: 'Low risk (< ' + inc + ' cm)', tone: 'ok' };
  };

  /* Heart health (simplified Life's Essential 8) */
  calc.le8 = {
    diet: function (yesCount) { return yesCount >= 8 ? 100 : yesCount >= 6 ? 80 : yesCount >= 4 ? 50 : yesCount >= 2 ? 25 : 0; },
    activity: function (min) { return min >= 150 ? 100 : min >= 120 ? 90 : min >= 90 ? 80 : min >= 60 ? 60 : min >= 30 ? 40 : min >= 1 ? 20 : 0; },
    nicotine: function (status, secondhand) {
      var s = { never: 100, quit5: 75, quit1: 50, quit0: 25, current: 0 }[status];
      if (secondhand) s -= 20;
      return Math.max(0, s);
    },
    sleep: function (h) { return (h >= 7 && h < 9) ? 100 : (h >= 9 && h < 10) ? 90 : (h >= 6 && h < 7) ? 70 : ((h >= 5 && h < 6) || h >= 10) ? 40 : (h >= 4 && h < 5) ? 20 : 0; },
    bmi: function (b) { b = r1(b); return b < 25 ? 100 : b < 30 ? 70 : b < 35 ? 30 : b < 40 ? 15 : 0; },
    lipids: function (nonHdl, treated) {
      var s = nonHdl < 130 ? 100 : nonHdl < 160 ? 60 : nonHdl < 190 ? 40 : nonHdl < 220 ? 20 : 0;
      if (treated) s -= 20; return Math.max(0, s);
    },
    glucose: function (k) { return { normal: 100, pre: 60, d7: 40, d8: 30, d9: 20, d10: 10, d11: 0 }[k]; },
    bp: function (sys, dia, treated) {
      var s = (sys >= 160 || dia >= 100) ? 0 : (sys >= 140 || dia >= 90) ? 25 : (sys >= 130 || dia >= 80) ? 50 : (sys >= 120) ? 75 : 100;
      if (treated) s -= 20; return Math.max(0, s);
    }
  };
  calc.le8Band = function (score) {
    return score >= 80 ? { key: 'high', label: 'High cardiovascular health', tone: 'ok' }
      : score >= 50 ? { key: 'moderate', label: 'Moderate cardiovascular health', tone: 'warn' }
        : { key: 'low', label: 'Low cardiovascular health', tone: 'danger' };
  };

  /* Sleep */
  calc.SLEEP_CYCLES = [6, 5, 4, 3];
  calc.sleepTimes = function (mode, minutesOfDay, latency) {
    return calc.SLEEP_CYCLES.map(function (c) {
      var t = mode === 'wake'
        ? minutesOfDay - latency - c * 90   /* given wake-up time -> bedtime */
        : minutesOfDay + latency + c * 90;  /* given bedtime -> wake-up time */
      t = ((t % 1440) + 1440) % 1440;
      return { cycles: c, hours: c * 1.5, minutes: t };
    });
  };
  calc.fmtTime = function (m) {
    var h = Math.floor(m / 60), mm = m % 60, ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + (mm < 10 ? '0' : '') + mm + ' ' + ap;
  };

  /* Target heart rate */
  calc.maxHR = function (age, formula) { return formula === 'tanaka' ? 208 - 0.7 * age : 220 - age; };
  calc.hrAt = function (pct, max, rest) { return rest ? (max - rest) * pct + rest : max * pct; };
  calc.ZONES = [
    { z: 1, name: 'Very light', lo: 0.50, hi: 0.60, use: 'Warm-up, cool-down, recovery walks', color: '#7aa6c2' },
    { z: 2, name: 'Light (fat-burning / base)', lo: 0.60, hi: 0.70, use: 'Easy steady cardio, builds endurance', color: '#4f9a6a' },
    { z: 3, name: 'Moderate (aerobic)', lo: 0.70, hi: 0.80, use: 'Brisk running, cycling – improves fitness', color: '#c9a03c' },
    { z: 4, name: 'Hard (threshold)', lo: 0.80, hi: 0.90, use: 'Tempo efforts, short intervals', color: '#d9772f' },
    { z: 5, name: 'Maximum', lo: 0.90, hi: 1.00, use: 'Very short all-out sprints only', color: '#c0392b' }
  ];
  calc.thr = function (age, rest, formula) {
    var max = calc.maxHR(age, formula);
    var f = function (p) { return r0(calc.hrAt(p, max, rest)); };
    return {
      max: max,
      zones: calc.ZONES.map(function (z) { return { z: z.z, name: z.name, use: z.use, color: z.color, lo: f(z.lo), hi: f(z.hi), loPct: z.lo, hiPct: z.hi }; }),
      moderate: [f(0.50), f(0.70)],
      vigorous: [f(0.70), f(0.85)]
    };
  };

  /* Wellness */
  calc.wellnessBand = function (p) {
    return p >= 80 ? { key: 'excellent', label: 'Excellent', tone: 'ok' }
      : p >= 60 ? { key: 'good', label: 'Good', tone: 'ok' }
        : p >= 40 ? { key: 'fair', label: 'Fair', tone: 'warn' }
          : { key: 'attention', label: 'Needs attention', tone: 'danger' };
  };

  /* Unit helpers */
  calc.ftinToCm = function (ft, inch) { return (ft * 12 + (inch || 0)) * 2.54; };
  calc.lbToKg = function (lb) { return lb * 0.45359237; };
  calc.kgToLb = function (kg) { return kg / 0.45359237; };
  calc.inToCm = function (i) { return i * 2.54; };
  calc.cmToFtIn = function (cm) { var t = cm / 2.54, ft = Math.floor(t / 12), i = Math.round(t - ft * 12); if (i === 12) { ft++; i = 0; } return ft + '′ ' + i + '″'; };

  var CHHT = root.CHHT = root.CHHT || {};
  CHHT.calc = calc;
  if (typeof module !== 'undefined' && module.exports) { module.exports = calc; return; }

  /* ------------------------------------------------------------------ */
  /*  DOM HELPERS                                                         */
  /* ------------------------------------------------------------------ */
  var doc = document;
  var $ = function (sel, el) { return (el || doc).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(sel)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var fmt = function (n, d) { return Number(n).toLocaleString('en-US', { maximumFractionDigits: d || 0, minimumFractionDigits: d || 0 }); };
  var store = {
    get: function (k) { try { return root.localStorage.getItem('chht_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { root.localStorage.setItem('chht_' + k, v); } catch (e) { } }
  };

  function track(name, params) {
    params = params || {};
    try { if (typeof root.gtag === 'function') root.gtag('event', name, params); } catch (e) { }
    try { (root.dataLayer = root.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) { }
    try { if (typeof root.fbq === 'function') root.fbq('trackCustom', name, params); } catch (e) { }
    try { if (root.ttq && typeof root.ttq.track === 'function') root.ttq.track(name, params); } catch (e) { }
  }
  CHHT.track = track;

  function num(form, name) {
    var el = form.elements[name];
    if (!el) return NaN;
    var v = String(el.value).replace(',', '.').trim();
    return v === '' ? NaN : parseFloat(v);
  }
  function val(form, name) {
    var el = form.elements[name];
    if (!el) return '';
    if (el.length !== undefined && !el.tagName) { /* RadioNodeList */
      for (var i = 0; i < el.length; i++) if (el[i].checked) return el[i].value;
      return '';
    }
    return el.value;
  }
  function fieldOf(el) { return el && el.closest('.chht-field, .chht-q'); }
  function setErr(form, name, msg) {
    var el = form.elements[name];
    var node = el && (el.tagName ? el : el[0]);
    var f = fieldOf(node);
    if (!f) return;
    f.classList.add('is-invalid');
    var e = $('.chht-err', f);
    if (e) e.textContent = msg;
  }
  function clearErrs(form) {
    $$('.is-invalid', form).forEach(function (f) { f.classList.remove('is-invalid'); });
    $$('.chht-err', form).forEach(function (e) { e.textContent = ''; });
  }
  function firstErrFocus(form) {
    var f = $('.is-invalid', form);
    if (!f) return;
    var input = $('input, select', f);
    if (input) input.focus({ preventScroll: true });
    f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function req(form, name, min, max, label, unit) {
    var v = num(form, name);
    if (isNaN(v)) { setErr(form, name, 'Please enter your ' + label + '.'); return NaN; }
    if (v < min || v > max) { setErr(form, name, 'Enter a ' + label + ' between ' + min + ' and ' + max + (unit ? ' ' + unit : '') + '.'); return NaN; }
    return v;
  }

  /* Units: each measurement has its own unit dropdown inside the field.
     hunit = ftin|cm (height), wunit = kg|lb (weight), xunit = in|cm (waist). */
  var UNIT_DEF = { hunit: 'ftin', wunit: 'kg', xunit: 'in' };
  function unitOf(form, n) { var el = form.elements[n]; return (el && el.value) || UNIT_DEF[n]; }
  function syncUnits(tool) {
    var form = $('form', tool);
    $$('[data-show-u]', tool).forEach(function (el) {
      var c = el.getAttribute('data-show-u').split(':'), on = unitOf(form, c[0]) === c[1];
      el.hidden = !on;
      $$('input,select', el).forEach(function (i) { i.disabled = !on; });
    });
    $$('select[data-unit-select]', tool).forEach(function (sel) {
      var f = fieldOf(sel), lab = f && $('label.chht-label', f), first = f && $('.chht-input:not([hidden]) input', f);
      if (lab && first) lab.setAttribute('for', first.id);
    });
  }
  /* Carry a typed value across when the unit changes (e.g. 170 cm -> 5 ft 7 in). */
  function convertUnit(form, n) {
    var u = unitOf(form, n), r = function (x, d) { var m = Math.pow(10, d || 0); return Math.round(x * m) / m; };
    var set = function (name, v) { if (form.elements[name]) form.elements[name].value = v; };
    if (n === 'hunit') {
      if (u === 'cm') { var ft = num(form, 'height_ft'), inch = num(form, 'height_in'); if (!isNaN(ft)) set('height_cm', r(calc.ftinToCm(ft, isNaN(inch) ? 0 : inch))); }
      else { var cm = num(form, 'height_cm'); if (!isNaN(cm)) { var t = cm / 2.54, f = Math.floor(t / 12), i = Math.round(t - f * 12); if (i === 12) { f++; i = 0; } set('height_ft', f); set('height_in', i); } }
    } else if (n === 'wunit') {
      if (u === 'lb') { var kg = num(form, 'weight_kg'); if (!isNaN(kg)) set('weight_lb', r(calc.kgToLb(kg))); }
      else { var lb = num(form, 'weight_lb'); if (!isNaN(lb)) set('weight_kg', r(calc.lbToKg(lb), 1)); }
    } else if (n === 'xunit') {
      if (u === 'cm') { var wi = num(form, 'waist_in'); if (!isNaN(wi)) set('waist_cm', r(calc.inToCm(wi))); }
      else { var wc = num(form, 'waist_cm'); if (!isNaN(wc)) set('waist_in', r(wc / 2.54, 1)); }
    }
  }
  function restoreUnits(tool) {
    var form = $('form', tool);
    Object.keys(UNIT_DEF).forEach(function (n) {
      var el = form.elements[n], v = store.get(n);
      if (el && v && $('option[value="' + v + '"]', el)) el.value = v;
    });
    syncUnits(tool);
  }
  function readHeight(form) {
    if (unitOf(form, 'hunit') === 'ftin') {
      var ft = num(form, 'height_ft'), inch = num(form, 'height_in');
      if (isNaN(inch)) inch = 0;
      if (isNaN(ft)) { setErr(form, 'height_ft', 'Please enter your height.'); return NaN; }
      var cm = calc.ftinToCm(ft, inch);
      if (ft < 3 || ft > 8 || inch < 0 || inch >= 12 || cm < 100 || cm > 250) { setErr(form, 'height_ft', 'Enter a height between 3′ 4″ and 8′ 2″.'); return NaN; }
      return cm;
    }
    return req(form, 'height_cm', 100, 250, 'height', 'cm');
  }
  function readWeight(form, optional) {
    var imp = unitOf(form, 'wunit') === 'lb', name = imp ? 'weight_lb' : 'weight_kg';
    var v = num(form, name);
    if (isNaN(v)) { if (optional) return null; setErr(form, name, 'Please enter your weight.'); return NaN; }
    var kg = imp ? calc.lbToKg(v) : v;
    if (kg < 25 || kg > 300) { setErr(form, name, imp ? 'Enter a weight between 55 and 660 lb.' : 'Enter a weight between 25 and 300 kg.'); return NaN; }
    return kg;
  }
  function readWaist(form) {
    var imp = unitOf(form, 'xunit') === 'in', name = imp ? 'waist_in' : 'waist_cm';
    var v = num(form, name);
    if (isNaN(v)) { setErr(form, name, 'Please enter your waist measurement.'); return NaN; }
    var cm = imp ? calc.inToCm(v) : v;
    if (cm < 40 || cm > 200) { setErr(form, name, imp ? 'Enter a waist between 16 and 79 inches.' : 'Enter a waist between 40 and 200 cm.'); return NaN; }
    return cm;
  }
  function wfmt(kg, form) { return unitOf(form, 'wunit') === 'lb' ? fmt(calc.kgToLb(kg)) + ' lb' : fmt(kg, kg < 100 ? 1 : 0) + ' kg'; }
  function hfmt(cm, form) { return unitOf(form, 'hunit') === 'ftin' ? calc.cmToFtIn(cm) : fmt(cm) + ' cm'; }

  function badge(b) { return '<span class="chht-badge chht-t-' + b.tone + '">' + esc(b.label) + '</span>'; }
  function callout(tone, html) { return '<div class="chht-callout chht-t-' + tone + '">' + html + '</div>'; }
  var TONE_COLORS = { ok: '#2f7d4f', warn: '#d1a03a', high: '#d9772f', danger: '#c0392b', info: '#5b8db8' };

  function gauge(segments, min, max, value, labels) {
    var span = max - min, clampV = Math.min(max, Math.max(min, value));
    var html = '<div class="chht-gauge" aria-hidden="true"><div class="chht-gauge-bar">';
    segments.forEach(function (s) { html += '<span style="width:' + ((s.to - s.from) / span * 100) + '%;background:' + s.color + '"></span>'; });
    html += '<i class="chht-gauge-marker" style="left:0%" data-left="' + ((clampV - min) / span * 100) + '"></i></div><div class="chht-gauge-labels">';
    labels.forEach(function (l) { html += '<span style="left:' + ((l - min) / span * 100) + '%">' + l + '</span>'; });
    return html + '</div></div>';
  }

  function showResult(tool, html, meta) {
    var box = $('.chht-result', tool);
    box.innerHTML = html + '<div class="chht-res-actions"><button type="button" class="chht-btn chht-btn-ghost" data-chht-reset>↺ Start again</button>' +
      (navigator.share ? '<button type="button" class="chht-btn chht-btn-ghost" data-chht-share>Share this tool</button>' : '<button type="button" class="chht-btn chht-btn-ghost" data-chht-copy>Copy link</button>') + '</div>';
    box.hidden = false;
    box.setAttribute('tabindex', '-1');
    requestAnimationFrame(function () {
      $$('.chht-gauge-marker', box).forEach(function (m) { m.style.left = m.getAttribute('data-left') + '%'; });
      $$('[data-w]', box).forEach(function (b) { b.style.width = b.getAttribute('data-w') + '%'; });
    });
    var rect = box.getBoundingClientRect();
    if (rect.top > root.innerHeight * 0.6 || rect.top < 0) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    box.focus({ preventScroll: true });
    track('chht_tool_complete', Object.assign({ tool: tool.getAttribute('data-chht-tool') }, meta || {}));
    if (!(meta && (meta.result_band === 'crisis' || meta.result_band === 'stage2'))) revealCta();
  }

  /* ------------------------------------------------------------------ */
  /*  TOOL CONTROLLERS                                                    */
  /* ------------------------------------------------------------------ */
  var tools = {};

  tools.bmi = function (tool, form) {
    var cm = readHeight(form), kg = readWeight(form);
    if (isNaN(cm) || isNaN(kg)) return false;
    var asian = form.elements.asian.checked;
    var b = calc.bmi(kg, cm), cat = calc.bmiCategory(b, asian), rg = calc.healthyRange(cm, asian);
    var segs = asian
      ? [{ from: 15, to: 18.5, color: TONE_COLORS.info }, { from: 18.5, to: 23, color: TONE_COLORS.ok }, { from: 23, to: 27.5, color: TONE_COLORS.warn }, { from: 27.5, to: 40, color: TONE_COLORS.danger }]
      : [{ from: 15, to: 18.5, color: TONE_COLORS.info }, { from: 18.5, to: 25, color: TONE_COLORS.ok }, { from: 25, to: 30, color: TONE_COLORS.warn }, { from: 30, to: 35, color: TONE_COLORS.high }, { from: 35, to: 40, color: TONE_COLORS.danger }];
    var labels = asian ? [15, 18.5, 23, 27.5, 40] : [15, 18.5, 25, 30, 35, 40];
    var diff = '';
    if (kg < rg.min) diff = 'You are about <strong>' + wfmt(rg.min - kg, form) + ' below</strong> the healthy range for your height.';
    else if (kg > rg.max) diff = 'Reaching the top of the healthy range would mean losing about <strong>' + wfmt(kg - rg.max, form) + '</strong>. Even a 5–10% loss brings real health benefits.';
    else diff = 'You are <strong>within</strong> the healthy weight range for your height. Keep it up!';
    var advice = {
      under: 'A low BMI can mean low muscle or nutrient stores. If it is unplanned, speak to a doctor.',
      healthy: 'Pair your BMI with your <a class="chht-link" href="/pages/ideal-weight-calculator">waist-to-height ratio</a> — belly fat matters too.',
      over: 'Check your <a class="chht-link" href="/pages/diabetes-risk-calculator">diabetes risk</a> and <a class="chht-link" href="/pages/calorie-calculator">daily calorie needs</a> to plan small, steady changes.',
      obese: 'A higher BMI raises the risk of diabetes, high blood pressure and heart disease. Consider a check-up and see your <a class="chht-link" href="/pages/diabetes-risk-calculator">diabetes risk</a>.'
    };
    var adv = advice[cat.key] || advice.obese;
    var html = '<div class="chht-res-head"><div class="chht-big">' + fmt(b, 1) + '<small>BMI</small></div>' + badge(cat) + '</div>' +
      gauge(segs, 15, 40, b, labels) +
      '<div class="chht-stats"><div class="chht-stat is-key"><b>' + wfmt(rg.min, form) + ' – ' + wfmt(rg.max, form) + '</b><span>Healthy weight for ' + hfmt(cm, form) + '</span></div>' +
      '<div class="chht-stat"><b>' + wfmt(kg, form) + '</b><span>Your weight</span></div>' +
      '<div class="chht-stat"><b>' + (asian ? '18.5 – 22.9' : '18.5 – 24.9') + '</b><span>Healthy BMI (' + (asian ? 'South Asian' : 'WHO') + ')</span></div></div>' +
      '<p class="chht-res-text">' + diff + '</p>' + callout(cat.tone, '<p>' + adv + '</p>');
    showResult(tool, html, { result_band: cat.key, asian: asian ? 'yes' : 'no' });
    return true;
  };

  tools.bp = function (tool, form) {
    var sys = req(form, 'systolic', 70, 250, 'systolic (top) number', 'mmHg');
    var dia = req(form, 'diastolic', 40, 150, 'diastolic (bottom) number', 'mmHg');
    var pulse = num(form, 'pulse');
    if (!isNaN(pulse) && (pulse < 30 || pulse > 220)) { setErr(form, 'pulse', 'Enter a pulse between 30 and 220 bpm, or leave it blank.'); return false; }
    if (isNaN(sys) || isNaN(dia)) return false;
    if (dia >= sys) { setErr(form, 'diastolic', 'The bottom number should be lower than the top number. Please check your reading.'); return false; }
    var c = calc.bp(sys, dia);
    var msgs = {
      crisis: '<p><strong>This reading is dangerously high.</strong> Wait 5 minutes and measure again. If it stays this high — or you have chest pain, shortness of breath, severe headache, vision changes, weakness or numbness — <strong>call 1122 or go to the nearest emergency department now.</strong></p>',
      stage2: '<p>Readings at this level need medical attention. Book a doctor’s appointment soon, keep a log of home readings, and don’t start or stop any medicine without advice.</p>',
      stage1: '<p>Your reading is in the high range. Re-check on 2–3 different days. If it stays here, see a doctor — lifestyle changes like less salt and more activity often help.</p>',
      elevated: '<p>Your top number is slightly raised. This is an early warning sign — cutting salt, staying active and managing weight can bring it back to normal.</p>',
      low: '<p>Low readings are often fine if you feel well. If you get dizziness, fainting, blurred vision or confusion, speak to a doctor.</p>',
      normal: '<p>Great — your reading is in the healthy range. Check at least once a year (more often if you’re over 40 or have risk factors).</p>'
    };
    var rows = [
      ['normal', 'Normal', '< 120', 'and < 80', TONE_COLORS.ok],
      ['elevated', 'Elevated', '120–129', 'and < 80', TONE_COLORS.warn],
      ['stage1', 'High – Stage 1', '130–139', 'or 80–89', TONE_COLORS.high],
      ['stage2', 'High – Stage 2', '≥ 140', 'or ≥ 90', TONE_COLORS.danger],
      ['crisis', 'Hypertensive crisis', '> 180', 'and/or > 120', '#7a1d14'],
      ['low', 'Low', '< 90', 'or < 60', TONE_COLORS.info]
    ];
    var table = '<table class="chht-rtable"><thead><tr><th>Category</th><th>Systolic</th><th>Diastolic</th></tr></thead><tbody>' +
      rows.map(function (r) { return '<tr' + (r[0] === c.key ? ' class="is-hl"' : '') + '><td><span class="chht-dot" style="background:' + r[4] + '"></span>' + r[1] + '</td><td>' + r[2] + '</td><td>' + r[3] + '</td></tr>'; }).join('') + '</tbody></table>';
    var pulseHtml = '';
    if (!isNaN(pulse)) { var p = calc.pulse(pulse); pulseHtml = '<div class="chht-stat"><b>' + fmt(pulse) + ' bpm</b><span>Pulse · ' + esc(p.label) + '</span></div>'; }
    var html = '<div class="chht-res-head"><div class="chht-big">' + fmt(sys) + '/' + fmt(dia) + '<small>mmHg</small></div>' + badge(c) + '</div>' +
      (pulseHtml ? '<div class="chht-stats">' + pulseHtml + '</div>' : '') +
      callout(c.tone, msgs[c.key]) + table +
      '<p class="chht-res-text" style="font-size:13.5px;color:var(--chht-muted)">One reading isn’t a diagnosis. Measure seated after 5 minutes’ rest, arm at heart level, no caffeine or smoking for 30 minutes. NHS guidance treats <strong>home</strong> readings of 135/85 or more as high.</p>';
    showResult(tool, html, { result_band: c.key });
    return true;
  };

  tools.calorie = function (tool, form) {
    var sex = val(form, 'sex');
    if (!sex) setErr(form, 'sex', 'Please choose one.');
    var age = req(form, 'age', 18, 80, 'age', 'years');
    var cm = readHeight(form), kg = readWeight(form);
    var activity = val(form, 'activity'), goal = val(form, 'goal');
    if (!sex || isNaN(age) || isNaN(cm) || isNaN(kg)) return false;
    var o = calc.calories({ sex: sex, age: age, cm: cm, kg: kg, activity: activity, goal: goal });
    var g = calc.GOALS[goal];
    var html = '<div class="chht-res-head"><div class="chht-big">' + fmt(o.target) + '<small>kcal / day</small></div>' + badge({ label: g.label, tone: 'info' }) + '</div>' +
      '<div class="chht-stats">' +
      '<div class="chht-stat is-key"><b>' + fmt(o.protein[0]) + '–' + fmt(o.protein[1]) + ' g</b><span>Protein per day</span></div>' +
      '<div class="chht-stat"><b>' + fmt(o.fat[0]) + '–' + fmt(o.fat[1]) + ' g</b><span>Fat (25–30% of calories)</span></div>' +
      '<div class="chht-stat"><b>≈ ' + fmt(o.carbs) + ' g</b><span>Carbohydrates</span></div>' +
      '<div class="chht-stat"><b>' + fmt(o.tdee) + '</b><span>Maintenance calories (TDEE)</span></div>' +
      '<div class="chht-stat"><b>' + fmt(o.bmr) + '</b><span>BMR (calories at rest)</span></div>' +
      '</div>' +
      '<p class="chht-res-text">Protein target: <strong>' + o.proteinPerKg[0] + '–' + o.proteinPerKg[1] + ' g per kg</strong> of ' + (o.usedRef ? 'reference body weight (' + wfmt(o.refKg, form) + ', the weight at BMI 25 for your height)' : 'body weight') + '. Spread it across 3–4 meals — eggs, daal, chanay, dahi, chicken and fish all count.</p>' +
      (o.clamped ? callout('warn', '<p>Your goal would put you at ' + fmt(o.wantedTarget) + ' kcal, which is below the safe minimum of <strong>' + fmt(o.floor) + ' kcal</strong> without medical supervision, so we’ve set your target to ' + fmt(o.floor) + ' kcal. Choose a slower goal or add activity instead.</p>') : '') +
      callout('info', '<p>These are estimates — real needs vary by about ±10%. Track your weight for 2–3 weeks and adjust by 100–200 kcal if it isn’t moving as expected.</p>');
    showResult(tool, html, { result_band: goal, activity: activity });
    return true;
  };

  tools.diabetes = function (tool, form) {
    var sex = val(form, 'sex'), activity = val(form, 'activity'), family = val(form, 'family');
    if (!sex) setErr(form, 'sex', 'Please choose one.');
    var age = req(form, 'age', 18, 100, 'age', 'years');
    var waist = readWaist(form);
    if (!activity) setErr(form, 'activity', 'Please choose your activity level.');
    if (!family) setErr(form, 'family', 'Please choose an option.');
    if (!sex || isNaN(age) || isNaN(waist) || !activity || !family) return false;
    var o = calc.idrs({ sex: sex, age: age, waist: waist, activity: activity, family: family });
    var msgs = {
      low: '<p>Your risk of developing type 2 diabetes is low right now. Keep active, watch your waist size, and re-take this test every year. Adults over 35 should still have a blood sugar test from time to time.</p>',
      moderate: '<p>You have a moderate risk. Small changes now make a big difference: walk 30 minutes a day, cut sugary drinks and mithai, and aim for a smaller waist. Get a <strong>fasting blood sugar or HbA1c test within the next year</strong>.</p>',
      high: '<p><strong>You have a high risk of type 2 diabetes.</strong> Please get a <strong>fasting blood sugar or HbA1c test soon</strong> — many people with diabetes in Pakistan don’t know they have it. Losing 5–7% of body weight and 150 minutes of activity a week can lower your risk substantially.</p>'
    };
    var parts = [['Age', o.parts.age, 30], ['Waist size', o.parts.waist, 20], ['Physical activity', o.parts.activity, 30], ['Family history', o.parts.family, 20]];
    var bars = '<div class="chht-bars">' + parts.map(function (p) {
      var pct = p[1] / p[2] * 100;
      return '<div class="chht-barrow"><span>' + p[0] + '</span><span class="chht-bartrack"><i data-w="' + pct + '" style="width:0;background:' + (pct >= 66 ? TONE_COLORS.danger : pct > 0 ? TONE_COLORS.warn : TONE_COLORS.ok) + '"></i></span><b>' + p[1] + '/' + p[2] + '</b></div>';
    }).join('') + '</div>';
    var html = '<div class="chht-res-head"><div class="chht-big">' + o.total + '<small>/ 100</small></div>' + badge(o.band) + '</div>' +
      gauge([{ from: 0, to: 30, color: TONE_COLORS.ok }, { from: 30, to: 60, color: TONE_COLORS.warn }, { from: 60, to: 100, color: TONE_COLORS.danger }], 0, 100, o.total, [0, 30, 60, 100]) +
      callout(o.band.tone, msgs[o.band.key]) +
      '<p class="chht-res-text"><strong>What added to your score:</strong></p>' + bars +
      '<p class="chht-res-text" style="font-size:13.5px;color:var(--chht-muted)">Reference: fasting blood sugar under 100 mg/dL is normal, 100–125 suggests prediabetes and 126+ (on two tests) suggests diabetes. HbA1c: under 5.7% normal, 5.7–6.4% prediabetes, 6.5%+ diabetes.</p>';
    showResult(tool, html, { result_band: o.band.key, score: o.total });
    return true;
  };

  tools.idealweight = function (tool, form) {
    var sex = val(form, 'sex');
    if (!sex) setErr(form, 'sex', 'Please choose one.');
    var cm = readHeight(form), waist = readWaist(form), kg = readWeight(form, true);
    if (!sex || isNaN(cm) || isNaN(waist) || (kg !== null && isNaN(kg))) return false;
    var asian = form.elements.asian.checked;
    var ib = calc.ibw(sex, cm), rg = calc.healthyRange(cm, asian), w = calc.whtr(waist, cm), wr = calc.waistRisk(sex, waist, asian);
    var formulas = ib.valid ? '<table class="chht-rtable"><thead><tr><th>Formula</th><th>Ideal weight</th></tr></thead><tbody>' +
      [['Devine (1974)', ib.devine], ['Robinson (1983)', ib.robinson], ['Miller (1983)', ib.miller], ['Hamwi (1964)', ib.hamwi]].map(function (f) { return '<tr><td>' + f[0] + '</td><td>' + wfmt(f[1], form) + '</td></tr>'; }).join('') +
      '<tr class="is-hl"><td>Healthy BMI range (' + (asian ? 'South Asian' : 'WHO') + ')</td><td>' + wfmt(rg.min, form) + ' – ' + wfmt(rg.max, form) + '</td></tr></tbody></table>'
      : callout('info', '<p>The classic ideal-weight formulas aren’t reliable below 152 cm (5 ft), so we’re showing your healthy BMI weight range only.</p>');
    var avg = ib.valid ? (ib.devine + ib.robinson + ib.miller + ib.hamwi) / 4 : (rg.min + rg.max) / 2;
    var cur = '';
    if (kg !== null) {
      if (kg > rg.max) cur = 'Your current weight (' + wfmt(kg, form) + ') is about <strong>' + wfmt(kg - rg.max, form) + ' above</strong> the healthy range.';
      else if (kg < rg.min) cur = 'Your current weight (' + wfmt(kg, form) + ') is about <strong>' + wfmt(rg.min - kg, form) + ' below</strong> the healthy range.';
      else cur = 'Your current weight (' + wfmt(kg, form) + ') is <strong>within</strong> the healthy range for your height.';
    }
    var html = '<div class="chht-res-head"><div class="chht-big">' + wfmt(avg, form).replace(/ (kg|lb)$/, '<small>$1</small>') + '</div>' + badge({ label: 'Average ideal weight', tone: 'info' }) + '</div>' +
      '<div class="chht-stats"><div class="chht-stat is-key"><b>' + wfmt(rg.min, form) + ' – ' + wfmt(rg.max, form) + '</b><span>Healthy weight range for ' + hfmt(cm, form) + '</span></div>' +
      '<div class="chht-stat"><b>' + fmt(w.ratio, 2) + '</b><span>Waist-to-height ratio</span></div>' +
      '<div class="chht-stat"><b>' + (unitOf(form, 'xunit') === 'in' ? fmt(waist / 2.54, 1) + '″' : fmt(waist) + ' cm') + '</b><span>Waist</span></div></div>' +
      (cur ? '<p class="chht-res-text">' + cur + '</p>' : '') +
      '<p class="chht-res-text"><strong>Waist-to-height ratio:</strong> ' + badge(w.band) + '</p>' +
      gauge([{ from: 0.3, to: 0.4, color: TONE_COLORS.info }, { from: 0.4, to: 0.5, color: TONE_COLORS.ok }, { from: 0.5, to: 0.6, color: TONE_COLORS.warn }, { from: 0.6, to: 0.75, color: TONE_COLORS.danger }], 0.3, 0.75, w.ratio, [0.3, 0.4, 0.5, 0.6, 0.75]) +
      callout(w.band.tone, '<p>' + ({
        low: 'A very low ratio can indicate being underweight. If you’ve lost weight without trying, speak to a doctor.',
        healthy: 'Your waist is less than half your height — a good sign for heart and metabolic health.',
        increased: 'Your waist is more than half your height. This points to extra belly (visceral) fat, which raises the risk of diabetes and heart disease. Aim to bring your waist under ' + (unitOf(form, 'xunit') === 'in' ? fmt(cm / 2 / 2.54, 1) + ' inches' : fmt(cm / 2) + ' cm') + '.',
        high: 'Your ratio suggests a high level of belly fat. Consider a check-up, and take our <a class="chht-link" href="/pages/diabetes-risk-calculator">diabetes risk test</a>.'
      }[w.band.key]) + '</p><p>Waist alone: ' + esc(wr.label) + '.</p>') +
      formulas;
    showResult(tool, html, { result_band: w.band.key });
    return true;
  };

  tools.heart = function (tool, form) {
    var ok = true;
    var vig = num(form, 'vigorous'), mod = num(form, 'moderate');
    if (isNaN(mod)) mod = 0; if (isNaN(vig)) vig = 0;
    if (mod < 0 || mod > 3000) { setErr(form, 'moderate', 'Enter minutes per week (0–3000).'); ok = false; }
    if (vig < 0 || vig > 3000) { setErr(form, 'vigorous', 'Enter minutes per week (0–3000).'); ok = false; }
    var smoke = val(form, 'smoke'); if (!smoke) { setErr(form, 'smoke', 'Please choose one.'); ok = false; }
    var sleep = req(form, 'sleep', 2, 16, 'average sleep', 'hours');
    var cm = readHeight(form), kg = readWeight(form);
    var bpKnown = val(form, 'bp_known') === 'yes', sys = NaN, dia = NaN;
    if (bpKnown) {
      sys = req(form, 'systolic', 70, 250, 'systolic number', 'mmHg'); dia = req(form, 'diastolic', 40, 150, 'diastolic number', 'mmHg');
      if (!isNaN(sys) && !isNaN(dia) && dia >= sys) { setErr(form, 'diastolic', 'The bottom number should be lower than the top number.'); ok = false; }
    }
    var cholMode = val(form, 'chol_known'), nonHdl = NaN;
    if (cholMode === 'nonhdl') nonHdl = req(form, 'nonhdl', 40, 400, 'non-HDL cholesterol', 'mg/dL');
    if (cholMode === 'total') {
      var tc = req(form, 'total_chol', 80, 500, 'total cholesterol', 'mg/dL'), hdl = req(form, 'hdl', 10, 150, 'HDL cholesterol', 'mg/dL');
      if (!isNaN(tc) && !isNaN(hdl)) { if (hdl >= tc) { setErr(form, 'hdl', 'HDL must be lower than total cholesterol.'); ok = false; } else nonHdl = tc - hdl; }
    }
    var gluc = val(form, 'glucose');
    if (!ok || isNaN(sleep) || isNaN(cm) || isNaN(kg) || (bpKnown && (isNaN(sys) || isNaN(dia))) || (cholMode !== 'unknown' && isNaN(nonHdl))) return false;
    var diet = $$('input[name="diet"]:checked', form).length;
    var L = calc.le8, bmiV = calc.bmi(kg, cm);
    var m = [
      { k: 'diet', label: 'Diet', s: L.diet(diet), tip: 'Add one more serving of fruit or vegetables daily and swap fried snacks for roasted chanay or nuts.' },
      { k: 'activity', label: 'Physical activity', s: L.activity(mod + vig * 2), tip: 'Build up to 150 minutes a week — a 30-minute brisk walk after dinner, five days a week, gets you there.' },
      { k: 'nicotine', label: 'Nicotine', s: L.nicotine(smoke, form.elements.secondhand.checked), tip: 'Quitting smoking, shisha or naswar is the single biggest step for your heart. Ask your doctor about support.' },
      { k: 'sleep', label: 'Sleep', s: L.sleep(sleep), tip: 'Aim for 7–9 hours: a fixed bedtime and no phone in bed help most people.' },
      { k: 'bmi', label: 'Body weight (BMI)', s: L.bmi(bmiV), tip: 'Losing even 5% of your weight improves blood pressure, sugar and cholesterol.' },
      { k: 'lipids', label: 'Cholesterol', s: isNaN(nonHdl) ? null : L.lipids(nonHdl, form.elements.chol_meds.checked), tip: 'Cut ghee, banaspati and fried food; eat more fibre (oats, daal, beans) and see your doctor about your lipid profile.' },
      { k: 'glucose', label: 'Blood sugar', s: gluc === 'unknown' ? null : L.glucose(gluc), tip: 'Limit sugary chai, soft drinks and mithai, walk after meals, and follow up with your doctor.' },
      { k: 'bp', label: 'Blood pressure', s: bpKnown ? L.bp(sys, dia, form.elements.bp_meds.checked) : null, tip: 'Use less salt (watch achar, chaat masala and packaged snacks) and check your BP regularly.' }
    ];
    var have = m.filter(function (x) { return x.s !== null; });
    var score = Math.round(have.reduce(function (a, x) { return a + x.s; }, 0) / have.length);
    var band = calc.le8Band(score);
    var color = function (s) { return s >= 80 ? TONE_COLORS.ok : s >= 50 ? TONE_COLORS.warn : TONE_COLORS.danger; };
    var bars = '<div class="chht-bars">' + m.map(function (x) {
      if (x.s === null) return '<div class="chht-barrow is-na"><span>' + x.label + '</span><span class="chht-bartrack"></span><b>–</b></div>';
      return '<div class="chht-barrow"><span>' + x.label + '</span><span class="chht-bartrack"><i data-w="' + x.s + '" style="width:0;background:' + color(x.s) + '"></i></span><b>' + x.s + '</b></div>';
    }).join('') + '</div>';
    var weakest = have.slice().sort(function (a, b) { return a.s - b.s; }).filter(function (x) { return x.s < 100; }).slice(0, 2);
    var missing = m.filter(function (x) { return x.s === null; }).map(function (x) { return x.label.toLowerCase(); });
    var html = '<div class="chht-res-head"><div class="chht-big">' + score + '<small>/ 100</small></div>' + badge(band) + '</div>' +
      gauge([{ from: 0, to: 50, color: TONE_COLORS.danger }, { from: 50, to: 80, color: TONE_COLORS.warn }, { from: 80, to: 100, color: TONE_COLORS.ok }], 0, 100, score, [0, 50, 80, 100]) +
      '<p class="chht-res-text"><strong>Your score by area</strong> (each out of 100):</p>' + bars +
      (weakest.length ? '<p class="chht-res-text"><strong>Your top areas to work on:</strong></p><ul class="chht-tips">' + weakest.map(function (x) { return '<li><strong>' + x.label + ' (' + x.s + '/100)</strong>' + x.tip + '</li>'; }).join('') + '</ul>' : '') +
      (missing.length ? callout('info', '<p>Your score is based on ' + have.length + ' of 8 areas. Ask your doctor for a check of your ' + missing.join(', ') + ' to complete the picture.</p>') : '') +
'';
    showResult(tool, html, { result_band: band.key, score: score });
    return true;
  };

  tools.sleep = function (tool, form) {
    var mode = val(form, 'mode');
    var t = form.elements[mode === 'wake' ? 'wake_time' : 'bed_time'].value;
    if (!/^\d{1,2}:\d{2}/.test(t)) { setErr(form, mode === 'wake' ? 'wake_time' : 'bed_time', 'Please choose a time.'); return false; }
    var parts = t.split(':'), mins = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    var lat = parseInt(val(form, 'latency'), 10) || 15;
    var list = calc.sleepTimes(mode, mins, lat);
    var tag = function (c) { return c >= 5 ? ['Recommended', 'chht-t-ok'] : c === 4 ? ['OK occasionally', 'chht-t-warn'] : ['Not enough', 'chht-t-danger']; };
    var cards = '<div class="chht-times">' + list.map(function (x) {
      var tg = tag(x.cycles);
      return '<div class="chht-time' + (x.cycles === 5 ? ' is-best' : '') + '"><b>' + calc.fmtTime(x.minutes) + '</b><span>' + x.cycles + ' cycles · ' + x.hours + ' h sleep</span><em class="' + tg[1] + '">' + tg[0] + '</em></div>';
    }).join('') + '</div>';
    var head = mode === 'wake'
      ? 'To wake up at <strong>' + calc.fmtTime(mins) + '</strong>, try to be <strong>in bed</strong> at one of these times:'
      : 'If you get into bed at <strong>' + calc.fmtTime(mins) + '</strong>, try to <strong>wake up</strong> at one of these times:';
    var html = '<p class="chht-res-text" style="margin-top:0;font-size:17px">' + head + '</p>' + cards +
      callout('info', '<p>We’ve allowed <strong>' + lat + ' minutes</strong> to fall asleep and 90-minute sleep cycles. Real cycles vary (about 70–120 minutes), so treat these as a guide. Adults need <strong>7–9 hours</strong>; a consistent schedule matters most.</p>');
    showResult(tool, html, { result_band: mode });
    return true;
  };

  tools.thr = function (tool, form) {
    var age = req(form, 'age', 15, 90, 'age', 'years');
    var rest = num(form, 'rest');
    if (!isNaN(rest) && (rest < 35 || rest > 120)) { setErr(form, 'rest', 'Enter a resting heart rate between 35 and 120 bpm, or leave it blank.'); return false; }
    if (isNaN(age)) return false;
    var formula = val(form, 'formula') || 'classic';
    var o = calc.thr(age, isNaN(rest) ? null : rest, formula);
    var table = '<table class="chht-rtable"><thead><tr><th>Zone</th><th>Best for</th><th>Heart rate</th></tr></thead><tbody>' +
      o.zones.map(function (z) { return '<tr><td><span class="chht-dot" style="background:' + z.color + '"></span><strong>Zone ' + z.z + '</strong> · ' + z.name + ' <span style="color:var(--chht-muted);font-size:12.5px">(' + Math.round(z.loPct * 100) + '–' + Math.round(z.hiPct * 100) + '%)</span></td><td style="font-size:13.5px;color:var(--chht-muted)">' + z.use + '</td><td>' + z.lo + '–' + z.hi + ' bpm</td></tr>'; }).join('') +
      '</tbody></table>';
    var html = '<div class="chht-res-head"><div class="chht-big">' + o.moderate[0] + '–' + o.vigorous[1] + '<small>bpm</small></div>' + badge({ label: 'Target exercise range', tone: 'ok' }) + '</div>' +
      '<div class="chht-stats">' +
      '<div class="chht-stat is-key"><b>' + o.moderate[0] + '–' + o.moderate[1] + '</b><span>Moderate (50–70%)</span></div>' +
      '<div class="chht-stat is-key"><b>' + o.vigorous[0] + '–' + o.vigorous[1] + '</b><span>Vigorous (70–85%)</span></div>' +
      '<div class="chht-stat"><b>' + Math.round(o.max) + '</b><span>Estimated max HR</span></div>' +
      (isNaN(rest) ? '' : '<div class="chht-stat"><b>' + rest + '</b><span>Resting HR (Karvonen used)</span></div>') +
      '</div>' + table +
      '<p class="chht-res-text"><strong>Quick check:</strong> count your pulse for 15 seconds and multiply by 4. For moderate exercise, that’s about <strong>' + Math.round(o.moderate[0] / 4) + '–' + Math.round(o.moderate[1] / 4) + ' beats in 15 seconds</strong>.</p>' +
      callout('warn', '<p>Formulas are estimates — your true maximum can differ by 10–12 bpm. Beta-blockers and some other medicines lower heart rate. Stop exercising and seek help (1122) if you get chest pain, severe breathlessness, dizziness or palpitations.</p>');
    showResult(tool, html, { result_band: formula, karvonen: isNaN(rest) ? 'no' : 'yes' });
    return true;
  };

  var WELL_TIPS = {
    sleep: [['Fix your wake-up time', 'Get up at the same time every day — even weekends. Your bedtime will naturally follow.'], ['Screens off 30–60 min before bed', 'Late-night scrolling delays sleep. Charge your phone outside the bedroom.'], ['Time your chai', 'Avoid tea, coffee and cola after mid-afternoon.']],
    activity: [['Walk after meals', 'A 10–15 minute walk after lunch and dinner adds up to 150 minutes a week.'], ['Add 2 strength days', 'Push-ups, squats, or resistance bands at home — 20 minutes is enough to start.'], ['Break up sitting', 'Stand or walk for 2–3 minutes every 30–60 minutes of desk time.']],
    hydration: [['Keep water in sight', 'Fill a 1-litre bottle in the morning and aim to finish it twice by evening — more in summer heat.'], ['Swap one sugary drink', 'Replace one soft drink or sweet chai a day with water, lassi without sugar or lemon water.'], ['Use the colour check', 'Pale straw-coloured urine usually means you are drinking enough.']],
    diet: [['Half-plate vegetables', 'Fill half your plate with sabzi or salad before adding roti or rice.'], ['Fry less, bake or grill more', 'Save samosas and pakoras for weekends; try air-fried or roasted snacks.'], ['Go whole-grain', 'Switch to chakki atta, add daal or chanay daily, and try brown rice or oats.']]
  };
  tools.wellness = function (tool, form) {
    var qs = $$('fieldset.chht-q', form), missing = 0;
    qs.forEach(function (q) { if (!$('input:checked', q)) { q.classList.add('is-invalid'); missing++; } });
    if (missing) { var e = $('.chht-form-err', form); if (e) e.textContent = 'Please answer all questions (' + missing + ' left).'; return false; }
    var areas = { sleep: 0, activity: 0, hydration: 0, diet: 0 };
    qs.forEach(function (q) { areas[q.getAttribute('data-area')] += parseInt($('input:checked', q).value, 10); });
    var labels = { sleep: 'Sleep', activity: 'Activity', hydration: 'Hydration', diet: 'Diet' };
    var pcts = {}; Object.keys(areas).forEach(function (k) { pcts[k] = Math.round(areas[k] / 9 * 100); });
    var overall = Math.round((pcts.sleep + pcts.activity + pcts.hydration + pcts.diet) / 4);
    var band = calc.wellnessBand(overall);
    var color = function (s) { return s >= 67 ? TONE_COLORS.ok : s >= 40 ? TONE_COLORS.warn : TONE_COLORS.danger; };
    var bars = '<div class="chht-bars">' + Object.keys(pcts).map(function (k) { return '<div class="chht-barrow"><span>' + labels[k] + '</span><span class="chht-bartrack"><i data-w="' + pcts[k] + '" style="width:0;background:' + color(pcts[k]) + '"></i></span><b>' + pcts[k] + '%</b></div>'; }).join('') + '</div>';
    var weak = Object.keys(pcts).filter(function (k) { return pcts[k] < 67; }).sort(function (a, b) { return pcts[a] - pcts[b]; });
    var tips = weak.length ? weak.map(function (k) {
      return '<p class="chht-res-text"><strong>' + labels[k] + ' — ' + pcts[k] + '%</strong></p><ul class="chht-tips">' + WELL_TIPS[k].map(function (t) { return '<li><strong>' + t[0] + '</strong>' + t[1] + '</li>'; }).join('') + '</ul>';
    }).join('') : callout('ok', '<p>All four areas are in good shape. Retake this assessment monthly to stay on track.</p>');
    var html = '<div class="chht-res-head"><div class="chht-big">' + overall + '<small>/ 100</small></div>' + badge(band) + '</div>' +
      gauge([{ from: 0, to: 40, color: TONE_COLORS.danger }, { from: 40, to: 60, color: TONE_COLORS.warn }, { from: 60, to: 100, color: TONE_COLORS.ok }], 0, 100, overall, [0, 40, 60, 80, 100]) +
      '<p class="chht-res-text"><strong>Your wellness by area:</strong></p>' + bars + tips +
      '<p class="chht-res-text" style="font-size:13.5px;color:var(--chht-muted)">General education only — not medical advice.</p>';
    showResult(tool, html, { result_band: band.key, score: overall });
    return true;
  };

  /* ------------------------------------------------------------------ */
  /*  INIT                                                                */
  /* ------------------------------------------------------------------ */
  function initTool(tool) {
    var key = tool.getAttribute('data-chht-tool'), form = $('form', tool), fn = tools[key];
    if (!form || !fn) return;
    restoreUnits(tool);
    var started = false;

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute && t.hasAttribute('data-unit-select')) { syncUnits(tool); convertUnit(form, t.name); store.set(t.name, t.value); var uf = fieldOf(t); if (uf) { uf.classList.remove('is-invalid'); var ue = $('.chht-err', uf); if (ue) ue.textContent = ''; } }
      if (t.type === 'radio' || t.type === 'checkbox' || t.tagName === 'SELECT') { var f = fieldOf(t); if (f) { f.classList.remove('is-invalid'); var er = $('.chht-err', f); if (er) er.textContent = ''; } }
      $$('[data-show-if]', tool).forEach(function (el) {
        var expr = el.getAttribute('data-show-if'), neg = expr.indexOf('!=') > -1, c = expr.split(neg ? '!=' : '=');
        var on = neg ? val(form, c[0]) !== c[1] : val(form, c[0]) === c[1];
        el.hidden = !on; $$('input,select', el).forEach(function (i) { i.disabled = !on; });
      });
      if (key === 'wellness') updateProgress(tool);
      if (!started) { started = true; track('chht_tool_start', { tool: key }); }
      if (!$('.chht-result', tool).hidden && t.type !== 'number' && t.type !== 'time' && t.name !== 'diet') { clearErrs(form); fn(tool, form); }
    });
    form.addEventListener('input', function (e) { var f = fieldOf(e.target); if (f && f.classList.contains('is-invalid')) { f.classList.remove('is-invalid'); var er = $('.chht-err', f); if (er) er.textContent = ''; } });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); clearErrs(form);
      var fe = $('.chht-form-err', form); if (fe) fe.textContent = '';
      if (!fn(tool, form)) firstErrFocus(form);
    });
    tool.addEventListener('click', function (e) {
      if (e.target.closest('[data-chht-reset]')) {
        form.reset(); clearErrs(form);
        restoreUnits(tool);
        form.dispatchEvent(new Event('change'));
        var box = $('.chht-result', tool); box.hidden = true; box.innerHTML = '';
        if (key === 'wellness') updateProgress(tool);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (e.target.closest('[data-chht-share]')) { navigator.share({ title: doc.title, url: location.href.split('?')[0] }).catch(function () { }); track('chht_share', { tool: key }); }
      if (e.target.closest('[data-chht-copy]')) {
        var b = e.target.closest('[data-chht-copy]');
        try { navigator.clipboard.writeText(location.href.split('?')[0]); b.textContent = '✓ Link copied'; } catch (err) { }
        track('chht_share', { tool: key });
      }
    });
    if (key === 'sleep') {
      var bt = form.elements.bed_time;
      if (bt && !bt.value) { var d = new Date(); bt.value = (d.getHours() < 10 ? '0' : '') + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes(); }
    }
    form.dispatchEvent(new Event('change'));
    started = false;
    if (key === 'wellness') updateProgress(tool);
  }
  function updateProgress(tool) {
    var qs = $$('fieldset.chht-q', tool), done = qs.filter(function (q) { return $('input:checked', q); }).length;
    var bar = $('.chht-progress i', tool), lab = $('.chht-progress-label', tool);
    if (bar) bar.style.width = (done / qs.length * 100) + '%';
    if (lab) lab.textContent = done + ' of ' + qs.length + ' answered';
  }

  /* Product CTA reveal + sticky bar + inline strip */
  var ctaShown = false;
  function revealCta() {
    var cta = $('[data-chht-cta="result"]');
    if (!cta || ctaShown) return;
    ctaShown = true; cta.hidden = false; cta.classList.add('is-reveal');
    track('chht_product_view', { placement: 'result_card', tool: pageTool() });
  }
  function pageTool() { var t = $('[data-chht-tool]'); return t ? t.getAttribute('data-chht-tool') : 'hub'; }

  function initCommerce() {
    doc.addEventListener('click', function (e) {
      var a = e.target.closest('[data-chht-product]');
      if (!a) return;
      track('chht_product_click', { placement: a.getAttribute('data-chht-placement') || '', product: a.getAttribute('data-chht-product'), tool: pageTool() });
    });
    /* Inline strip: move after the 3rd H2 of the article (or 2nd if short) */
    var tpl = $('#chht-inline-cta'), art = $('.chht-article');
    if (tpl && art) {
      var h2s = $$('h2', art), anchor = h2s[2] || h2s[1];
      if (anchor) anchor.parentNode.insertBefore(tpl.content.cloneNode(true), anchor);
    }
    /* Sticky bar */
    var bar = $('.chht-sticky');
    if (bar) {
      var dismissed = false;
      try { dismissed = root.sessionStorage.getItem('chht_sticky_x') === '1'; } catch (e) { }
      if (!dismissed) {
        var trigger = $('.chht-tool') || $('.chht-grid');
        var on = false, ticking = false;
        var check = function () {
          ticking = false;
          var past = trigger ? trigger.getBoundingClientRect().bottom < 0 : root.scrollY > 600;
          var nearEnd = (root.innerHeight + root.scrollY) > (doc.documentElement.scrollHeight - 500);
          var want = past && !nearEnd;
          if (want !== on) { on = want; bar.classList.toggle('is-on', on); if (on && !bar._seen) { bar._seen = true; track('chht_product_view', { placement: 'sticky_bar', tool: pageTool() }); } }
        };
        root.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        check();
      }
      var x = $('.chht-sticky-x', bar);
      if (x) x.addEventListener('click', function () { bar.classList.remove('is-on'); bar.hidden = true; try { root.sessionStorage.setItem('chht_sticky_x', '1'); } catch (e) { } });
    }
  }

  function initArticle() {
    var art = $('.chht-article');
    if (!art) return;
    $$('table', art).forEach(function (t) {
      if (t.parentNode.classList.contains('chht-table-wrap')) return;
      var w = doc.createElement('div'); w.className = 'chht-table-wrap'; w.setAttribute('tabindex', '0');
      t.parentNode.insertBefore(w, t); w.appendChild(t);
    });
    /* Table of contents from H2s */
    var h2s = $$('h2', art);
    if (h2s.length >= 4 && !$('.chht-toc', art)) {
      var slug = function (s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); };
      var used = {};
      var items = h2s.map(function (h) {
        var id = h.id || slug(h.textContent); while (used[id]) id += '-2'; used[id] = 1; h.id = id;
        return '<li><a href="#' + id + '">' + esc(h.textContent) + '</a></li>';
      }).join('');
      var toc = doc.createElement('details'); toc.className = 'chht-toc';
      toc.innerHTML = '<summary>On this page</summary><ol>' + items + '</ol>';
      art.insertBefore(toc, art.firstChild);
    }
    $$('a[href^="http"]', art).forEach(function (a) {
      if (a.hostname !== location.hostname) { a.target = '_blank'; if (!/noopener/.test(a.rel)) a.rel = (a.rel + ' noopener').trim(); }
    });
  }

  function init() {
    $$('[data-chht-tool]').forEach(initTool);
    initArticle();
    initCommerce();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})(typeof window !== 'undefined' ? window : globalThis);
